import _isString from 'lodash/isString';
import _isEmpty from 'lodash/isEmpty';
import Parameter, { BoolClause } from './Parameter';
import ParameterKeyValue from './ParameterKeyValue';
import { Category } from '../types';

/**
 * Ensure category is a valid, trimmed string
 *
 * @param {string} code
 * @returns {string[]}
 */
function formatCategory(category: string): string {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  if (_isEmpty(category) || !_isString(category)) return null;

  const trimmedCategory = category.trim();

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  return _isEmpty(trimmedCategory) ? null : trimmedCategory;
}

/**
 * Filter for fhir categories
 *
 * @export
 * @class CategoryFilter
 * @extends {Parameter}
 */
export default class CategoryFilter extends Parameter {
  private _categoriesString: string;
  private _fssCategories: Category[];

  constructor(useCategoryFilters: boolean, categories: Category[] = []) {
    super();

    if (!useCategoryFilters || _isEmpty(categories)) {
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      this._categoriesString = null;
      this._fssCategories = [];
    } else {
      this._fssCategories = categories;
      this._categoriesString = categories
        .map((category: Category = {} as Category) =>
          formatCategory(category.key),
        )
        .filter(Boolean)
        .join(',');
    }
  }

  get parameterKeyValue(): ParameterKeyValue {
    return new ParameterKeyValue('category', this._categoriesString);
  }

  async getFSSClause(): Promise<BoolClause | null> {
    if (!this._fssCategories?.length) return null;

    return {
      bool: {
        should: this._fssCategories.map(_ =>
          this._getFSSCodeableConceptClause('category', {
            system: _.system,
            code: _.key,
          }),
        ),
      },
    };
  }
}
